import { useState } from 'react'
import { router } from '@inertiajs/react'
import { AdminSidebar } from '@/components/layout/AdminSidebar'
import { Button } from '@/components/ui/Button'

interface Tag { id: number; name: string; slug: string; count: number }

export default function Index({ tags }: { tags: Tag[] }) {
  const [newTag, setNewTag] = useState('')

  const handleCreate = (e: React.FormEvent) => {
    e.preventDefault()
    if (!newTag.trim()) return
    router.post('/admin/tags', { name: newTag })
    setNewTag('')
  }

  const handleDelete = (id: number, name: string) => {
    if (!confirm(`Delete tag "${name}"?`)) return
    router.delete(`/admin/tags/${id}`)
  }

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <AdminSidebar active="/admin/tags" />
      <main className="flex-1 p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Tags</h1>

        {/* Create */}
        <form onSubmit={handleCreate} className="flex gap-3 mb-8">
          <input
            value={newTag}
            onChange={e => setNewTag(e.target.value)}
            placeholder="New tag name..."
            className="px-4 py-2 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-brand/20 w-64"
          />
          <Button type="submit" size="sm">Add tag</Button>
        </form>

        {/* List */}
        <div className="flex flex-wrap gap-3">
          {tags.map(tag => (
            <div key={tag.id} className="flex items-center gap-1.5 bg-white border border-gray-200 rounded-full px-3 py-1.5">
              <span className="text-sm font-medium text-gray-700">{tag.name}</span>
              <span className="text-xs text-gray-400">{tag.count}</span>
              <button
                onClick={() => handleDelete(tag.id, tag.name)}
                className="text-gray-300 hover:text-red-500 ml-1 text-xs"
              >×</button>
            </div>
          ))}
        </div>
        {tags.length === 0 && (
          <p className="text-gray-400 text-sm">No tags yet.</p>
        )}
      </main>
    </div>
  )
}
